/**
 * Avisos discretos (toasts). Outros módulos podem usar `showToast`/`dismissToast`.
 */
import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  /** Toasts com o mesmo id se substituem (evita repetição). */
  id: string;
  kind: ToastKind;
  message: string;
  /** Some sozinho após N ms (0 = só ao fechar ou ao ser removido). */
  timeoutMs: number;
  action?: { label: string; onClick: () => void };
}

interface ToastState {
  toasts: Toast[];
}

export const useToastStore = create<ToastState>()(() => ({ toasts: [] }));

const timers = new Map<string, ReturnType<typeof setTimeout>>();
let seq = 0;

export function showToast(t: Omit<Toast, 'id' | 'timeoutMs'> & { id?: string; timeoutMs?: number }): string {
  const id = t.id ?? `t${++seq}`;
  const toast: Toast = { timeoutMs: t.kind === 'error' ? 8000 : 4000, ...t, id };
  useToastStore.setState((s) => ({ toasts: [...s.toasts.filter((x) => x.id !== id), toast].slice(-4) }));
  clearTimeout(timers.get(id));
  timers.delete(id);
  if (toast.timeoutMs > 0) timers.set(id, setTimeout(() => dismissToast(id), toast.timeoutMs));
  return id;
}

export function dismissToast(id: string): void {
  clearTimeout(timers.get(id));
  timers.delete(id);
  useToastStore.setState((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
}
